import React, { useState } from "react";
import { Link } from "react-router-dom";
import BbsThreadList from "../components/BbsThreadList";
import BbsThread from "../components/BbsThread";
import "../styles/bbs.css";

export default function BbsPage({ currentUser = null }) {
  const [selectedThread, setSelectedThread] = useState(null);

  return (
    <div className="bbs-container">
      <h1 className="bbs-title">情報提供BBS</h1>
      <p className="bbs-rule-note">
        書き込む前に<Link to="/rule#bbs">BBSのルール</Link>をご一読ください。
      </p>
      {selectedThread ? (
        <BbsThread
          thread={selectedThread}
          onBack={() => setSelectedThread(null)}
          currentUser={currentUser}
        />
      ) : (
        <BbsThreadList onSelectThread={setSelectedThread} currentUser={currentUser} />
      )}
    </div>
  );
}
